export const MAX_IMAGE_UPLOAD_SIZE_MB = 1;
export const MAX_IMAGE_UPLOAD_SIZE = MAX_IMAGE_UPLOAD_SIZE_MB * 1000000;
// eslint-disable-next-line max-len
export const MAX_IMAGE_UPLOAD_SIZE_ERROR = `Maximum file size exceeded. File should be a maximum of ${MAX_IMAGE_UPLOAD_SIZE_MB}Mb, please check documentation for correct image dimensions or contact us via our Support Portal.`;
